import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import {
  ChevronLeft,
  ChevronRight,
  Mail,
  Phone,
  MapPinned
} from 'lucide-react';
import {
  HowItWorksSection,
  HowItWorksContainer,
  SectionTitle,
  StepsGrid,
  StepCard,
  StepNumber,
  StepH3,
  StepDescription,
  Footer,
  FooterContent,
  FooterColumn,
  Copyright
} from '../styles';

const recentMoves = [
  { id: 1, title: 'Furniture Move', from: 'Basingstoke', to: 'Basingstoke', cost: '60', saved: '22', img: '/customer1.webp', completionTime: '1 hour' },
  { id: 2, title: 'Home Removal', from: "Canning Town", to: 'Canary Wharf', cost: '640', saved: '377', img: '/customer6.webp', completionTime: '6 hours' },
  { id: 3, title: 'Flat Move & Storage', from: 'Canning Town', to: 'Croydon', cost: '450', saved: '45', img: '/customer8.webp', completionTime: '6 hours' },
  { id: 4, title: 'Furniture Move', from: 'Portsmouth', to: 'Portsmouth', cost: '45', saved: '80', img: '/customer7.webp', completionTime: '1 hour' },
];

export default function HowItWorksPage() {
  const carouselRef = useRef(null);

  const scrollLeft = () => {
    carouselRef.current?.scrollBy({
      left: -370,
      behavior: 'smooth'
    });
  };

  const scrollRight = () => {
    carouselRef.current?.scrollBy({
      left: 370,
      behavior: 'smooth'
    });
  };

  return (
    <main style={{ paddingTop: '125px' }}>

      <HowItWorksSection id="how-it-works">
              <HowItWorksContainer>
                <SectionTitle initial={{opacity:0,y:30}} whileInView={{opacity:1,y:0}} viewport={{once:true}} style={{color:'#1a1a1a'}}>How It Works</SectionTitle>
                

                <StepsGrid>
                  <StepCard style={{ boxShadow: "none" }} initial={{opacity:0,y:30}} whileInView={{opacity:1,y:0}} viewport={{once:true}}>
                    <StepNumber style={{ boxShadow: "none" }}>1</StepNumber><StepH3>Request a Quote</StepH3>
                    <StepDescription>Share your shipping details and get an instant quote.</StepDescription>
                  </StepCard>
                  <StepCard style={{ boxShadow: "none" }} initial={{opacity:0,y:30}} whileInView={{opacity:1,y:0}} viewport={{once:true}} transition={{delay:0.1}}>
                    <StepNumber style={{ boxShadow: "none" }}>2</StepNumber><StepH3>Schedule Pickup</StepH3>
                    <StepDescription>Choose a convenient pickup time from your location.</StepDescription>
                  </StepCard>
                  <StepCard style={{ boxShadow: "none" }} initial={{opacity:0,y:30}} whileInView={{opacity:1,y:0}} viewport={{once:true}} transition={{delay:0.2}}>
                    <StepNumber style={{ boxShadow: "none" }}>3</StepNumber><StepH3>Stay Updated</StepH3>
                    <StepDescription>We'll keep you informed via email and phone at every stage.</StepDescription>
                  </StepCard>
                  <StepCard style={{ boxShadow: "none" }} initial={{opacity:0,y:30}} whileInView={{opacity:1,y:0}} viewport={{once:true}} transition={{delay:0.3}}>
                    <StepNumber style={{ boxShadow: "none" }}>4</StepNumber><StepH3>Delivered</StepH3>
                    <StepDescription>Your shipment arrives safely and on time.</StepDescription>
                  </StepCard>
                </StepsGrid>
              </HowItWorksContainer>
            </HowItWorksSection>

                  {/* RECENT MOVES & REVIEWS (Added under Hero) */}
            <div style={{ background: '#F8F7F4', padding: '5rem 0', overflow: 'hidden' }}>
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '4rem',
                alignItems: 'flex-start',
                paddingLeft: 'max(5%, calc((100vw - 1400px) / 2))',
                width: '100%'
              }}>
                {/* Left Column */}
                <motion.div
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6 }}
                  style={{ flex: '1 1 400px', maxWidth: '500px', paddingLeft: '1rem', paddingRight: '2rem', paddingTop: '1.5rem' }}
                >
                  <h2 style={{ fontSize: '2.5rem', color: '#10243D', marginBottom: '1.5rem', lineHeight: '1.2', fontWeight: '800' }}>
                    Recent Moves &amp; Reviews
                  </h2>
<p style={{ fontSize: '1.1rem', color: '#10243D', marginBottom: '1.25rem', lineHeight: '1.7' }}>
                    From local furniture pickups to long-distance relocations, we handle jobs of all sizes. Our transparent pricing means you know exactly what you&apos;re paying upfront no hidden fees, just great service.
                  </p>
                  <p style={{ fontSize: '1.1rem', color: '#10243D', marginBottom: 0, lineHeight: '1.7' }}>
                    Available 24/7, we work around your schedule. Whether you need a last-minute office clearance or secure storage during a house move, our team is ready to help whenever you are.
                  </p>
                </motion.div>

                {/* Right Column: Carousel */}
                <div style={{ flex: '2 1 700px', minWidth: 0 }}>
                  <div
                    ref={carouselRef}
                    onScroll={(e) => {
                      const video = e.currentTarget.querySelector('video');
                      if (video && !video.paused) video.pause();
                    }}
                    style={{
                      display: 'flex',
                      gap: '1.5rem',
                      overflowX: 'auto',
                      scrollSnapType: 'x mandatory',
                      paddingBottom: '1.5rem',
                      scrollbarWidth: 'none',
                      WebkitOverflowScrolling: 'touch',
                      paddingRight: '5%',
                    }}
                  >
                    
                    {/* Video Testimonial */}
                    <div
                      style={{
                        minWidth: '340px',
                        flex: '0 0 auto',
                        background: '#000',
                        borderRadius: '12px',
                        border: '1px solid #e2e8f0',
                        overflow: 'hidden',
                        scrollSnapAlign: 'start',
                        position: 'relative',
                        minHeight: '420px'
                      }}
                    >
                      <video
                        src="/customer_new.mp4"
                        controls
                        playsInline
                        preload="metadata"
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          display: 'block'
                        }}
                      >
                        Your browser does not support the video tag.
                      </video>
                    </div>

                    {recentMoves.map((move) => (
                      <div
                        key={move.id}
                        style={{
                          minWidth: '340px',
                          flex: '0 0 auto',
                          background: '#fff',
                          borderRadius: '12px',
                          border: '1px solid #e2e8f0',
                          overflow: 'hidden',
                          scrollSnapAlign: 'start',
                          boxShadow: '0 4px 6px rgba(0,0,0,0.02)',
                          display: 'flex',
                          flexDirection: 'column'
                        }}
                      >
                        <div style={{ padding: '1rem 1rem 0 1rem' }}>
                          <img 
                            src={move.img} 
                            alt={move.title} 
                            style={{ 
                              width: '100%', 
                              height: '200px',
                              objectFit: 'cover', 
                              borderRadius: '12px', 
                              border: '1px solid #e2e8f0',
                              display: 'block'
                            }} 
                          />
                        </div>
                        
                        <div style={{ padding: '1.5rem', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                          <h3 style={{ fontSize: '1.4rem', color: '#1a1a1a', marginBottom: '1rem', fontWeight: '700' }}>
                            {move.title}
                          </h3>
                          <p style={{ margin: '0 0 0.5rem', color: '#475569', fontSize: '1.05rem' }}>From: <strong style={{ color: '#1a1a1a' }}>{move.from}</strong></p>
                          <p style={{ margin: '0 0 0.5rem', color: '#475569', fontSize: '1.05rem' }}>To: <strong style={{ color: '#1a1a1a' }}>{move.to}</strong></p>
                          <p style={{ margin: "0 0 0.5rem", color: "#475569", fontSize: "1.05rem" }}>Completion Time: <strong style={{ color: "#1a1a1a" }}>{move.completionTime}</strong></p>
                          <p style={{ margin: 0, color: '#475569', display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '1.05rem' }}>
                            Review: <span style={{ color: '#fbbc04', fontSize: '1.2rem', letterSpacing: '2px' }}>★★★★★</span>
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Carousel Controls */}
                  <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1rem', justifyContent: 'flex-start', paddingLeft: '1rem' }}>
                    <button
                      onClick={scrollLeft}
                      style={{ width: '44px', height: '44px', borderRadius: '50%', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10243D', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}
                    >
                      <ChevronLeft size={24} />
                    </button>
                    <button
                      onClick={scrollRight}
                      style={{ width: '44px', height: '44px', borderRadius: '50%', border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10243D', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}
                    >
                      <ChevronRight size={24} />
                    </button>
                  </div>
                </div>
              </div>
            </div>



                  <Footer>
              <FooterContent className="responsive-footer">
                <FooterColumn>
                  <h4>Urgent Logistics</h4>
                  <p>Reliable courier, transport and removals services across the UK, including London and the South Coast. From business deliveries to house moves and furniture transport, Urgent Logistics offers flexible solutions to get your items moving safely and efficiently.</p>
                </FooterColumn>
                <FooterColumn>
                  <h4>Contact Info</h4>
                  <p style={{display:'flex',alignItems:'center',gap:'8px',margin:'0 0 12px'}}><Mail size={16}/> info@urgentservicelogistics.co.uk</p>
                  <p style={{display:'flex',alignItems:'center',gap:'8px',margin:'0 0 12px'}}><Phone size={16}/><a href="tel:+447436117842" style={{color:'inherit',textDecoration:'none',lineHeight:'inherit'}}>07436 117842</a></p>
                  <p style={{display:'flex',alignItems:'center',gap:'8px',margin:'0 0 12px'}}><MapPinned size={16}/> Hampshire</p>
                </FooterColumn>
                <FooterColumn>
                  <h4>Operating Hours</h4>
                  <p style={{margin:'0 0 8px', lineHeight:'1.6'}}><strong>Deliveries:</strong> 24 Hours, 7 Days</p>
                  <p style={{margin:'0 0 8px', lineHeight:'1.6'}}><strong>Phone Support:</strong></p>
                  <p style={{margin:'0 0 8px', lineHeight:'1.6'}}>Mon &ndash; Sat: 08:00 am &ndash; 20:00 pm</p>
                  <p style={{margin:'0 0 8px', lineHeight:'1.6'}}>Sun: 09:00 am &ndash; 21:00 pm</p>
                </FooterColumn>
              </FooterContent>
              <Copyright>
                © 2025 Urgent Logistics. All rights reserved. 
                Website by <a href="https://draftpoint.co.uk" target="_blank" rel="noopener noreferrer" style={{color:'#ff6b35',textDecoration:'none'}}>Draftpoint</a>
              </Copyright>
            </Footer>

    </main>
  );
}
